import React from 'react';
import { useTranslation } from 'react-i18next';
import { Clock, ArrowRight } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Users } from 'lucide-react';

const PointagesPreviewCard = ({ previewList, dateRangeLabel }) => {
  const { t } = useTranslation();
  return (
  <Card>
    <CardHeader className="pb-3">
      <CardTitle className="text-base flex items-center gap-2">
        <Users className="h-4 w-4" />
        {t('attComp.preview.title')}
        <Badge variant="secondary" className="ml-1">{previewList.length}</Badge>
      </CardTitle>
      <CardDescription>{t('attComp.preview.plannings', { range: dateRangeLabel })}</CardDescription>
    </CardHeader>
    <CardContent>
      <div className="rounded-md border overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-muted/50">
              <TableHead className="w-32">{t('attComp.preview.matricule')}</TableHead>
              <TableHead>{t('attComp.preview.name')}</TableHead>
              <TableHead>{t('attComp.firstName')}</TableHead>
              <TableHead className="text-center">{t('attComp.preview.planning')}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {previewList.map(emp => (
              <TableRow key={emp.employee_id}>
                <TableCell className="font-mono text-sm">{emp.registration_number}</TableCell>
                <TableCell className="font-medium">{emp.last_name}</TableCell>
                <TableCell>{emp.first_name}</TableCell>
                <TableCell className="text-center">
                  {emp.expected_start && emp.expected_end ? (
                    <span className="inline-flex items-center gap-1 text-sm">
                      <Clock className="h-3 w-3 text-muted-foreground" />
                      <span className="font-mono">{emp.expected_start}</span>
                      <ArrowRight className="h-3 w-3 text-gray-400" />
                      <span className="font-mono">{emp.expected_end}</span>
                      {emp.schedule_name && (
                        <span className="text-xs text-muted-foreground ml-1">({emp.schedule_name})</span>
                      )}
                    </span>
                  ) : (
                    <span className="text-xs text-muted-foreground italic">{t('attComp.preview.noPlanning')}</span>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </CardContent>
  </Card>
  );
};

export default PointagesPreviewCard;
